var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 0C1.64162 0 0 1.64162 0 3.66667V6.6C0 15.1052 6.89481 22 15.4 22H18.3333C20.3584 22 22 20.3584 22 18.3333V16.3064C22 15.4732 21.5292 14.7114 20.7839 14.3387L17.2405 12.567C16.043 11.9683 14.5929 12.569 14.1695 13.8391L13.7328 15.1492C13.5669 15.647 13.0562 15.9434 12.5417 15.8405C9.32108 15.1964 6.80364 12.6789 6.15952 9.45832C6.05661 8.94378 6.35295 8.43313 6.85076 8.26719L8.47675 7.7252C9.56734 7.36167 10.1942 6.21977 9.91536 5.10451L9.05584 1.66642C8.811 0.687054 7.93104 0 6.92153 0H3.66667Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7481 0.214788L13.2 7.76291V4.4H11.7333V10.2667H17.6V8.8H14.2371L21.7852 1.25188L20.7481 0.214788Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.cef2903b483db8693b05479e4571d6d4.svg";
export { ForwardRef as ReactComponent };